
// import './assets/Table.css'
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useAuth0 } from "@auth0/auth0-react";
import { setShowVehicle, setSelectedVehicle, setSelectedVehicleHistory } from './redux/vehicleSlice.js'

import apiClient from './services/apiClient.js';
import PageConsumerDetailsAndReporting from './pageConsumerDetailsAndReporting.jsx';


const SingleVehicleModalV2 = () => {
    const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
    const showVehicle = useSelector((state) => state.vehicle.showVehicle);
    const selectedVehicle = useSelector((state) => state.vehicle.selectedVehicle);
    const selectedVehicleHistory = useSelector((state) => state.vehicle.selectedVehicleHistory);
    const dispatch = useDispatch()
    const [modalShow, setModalShow] = useState(false);
    const [vehicleDriveOffs, setVehicleDriveOffs] = useState([]);
    const [driveOffAmount, setDriveOffAmount] = useState('');
    const [reportedBy, setReportedBy] = useState(user.name);
    // const [historyCount, setHistoryCount] = useState(0);
    const [leftPanelView, setLeftPanelView] = useState('image'); // 'image', 'checkResults', 'reportForm'
    const [isLoading, _setIsLoading] = useState(false);
    const isLoadingRef = React.useRef(isLoading);

    const setIsLoading = data => {
        isLoadingRef.current = data;
        _setIsLoading(data);
    };

    const getDateTimeInfo = (dateTimeUtc) => {
        const locale = (navigator && navigator.language) || "en"
        const dateTimeInfo = dateTimeUtc ? new Date(dateTimeUtc).toLocaleString(locale, {
            dateStyle: "long",
            timeStyle: "short"
        }) : null
        return dateTimeInfo;
    }

    const handleModalClose = () => {
        // setVehicleInfo(null);
        setIsLoading(false)
        // setHistoryCount(0);
        setLeftPanelView('image');
        setDriveOffAmount('');
        setReportedBy(user.name);
        setVehicleDriveOffs([]); // Clear drive-offs when modal closes
        dispatch(setShowVehicle(false));
        dispatch(setSelectedVehicle(null));
        dispatch(setSelectedVehicleHistory([]));

    }
    const checkVehicleRegoStatusAsync = async () => {

        if (!isAuthenticated || user['/roles'].length === 0) {
            return;
        }


        const accessToken = await getAccessTokenSilently({
            authorizationParams: {
                audience: process.env.REACT_APP_AUTH0_API_AUDIENCE,
            }
        });

        const userRole = user['/roles'][0];

        const params = {
            registration: selectedVehicle.plate,
            currentRecordId: selectedVehicle.id,
            groupName: userRole,
            registrationCheckTime: getDateTimeInfo(new Date())
        };

        const {
            vehicleMake,
            vehicleModel,
            vehicleColour,
            isVehicleStolen,
            message,
            lookupStatus
        } = await apiClient.getVehicleRegistrationStatusManualCheckAsync(params, accessToken)

        setIsLoading(false);
        const newSelectedVehicle = Object.assign({}, selectedVehicle,
            { registeredMake: vehicleMake },
            { registeredModel: vehicleModel },
            { registeredColor: vehicleColour },
            { isVehicleStolen },
            { message },
            { lookupStatus: lookupStatus });
        dispatch(setSelectedVehicle(newSelectedVehicle));

    }

    const checkVehicleDriveOffsAsync = async (plate) => {

        if (!plate || !isAuthenticated || user['/roles'].length === 0) {
            return;
        }

        const accessToken = await getAccessTokenSilently({
            authorizationParams: {
                audience: process.env.REACT_APP_AUTH0_API_AUDIENCE,
            }
        });

        const userRole = user['/roles'][0];

        const params = {
            plate,
            groupName: userRole
        };

        const result = await apiClient.getVehicleDriveOffsForPlateAsync(params, accessToken)
        // console.log('🚨 Drive-offs API result for plate', plate, ':', result);
        // console.log('🚨 Number of drive-offs:', result ? result.length : 0);
        setVehicleDriveOffs(result);
        setIsLoading(false);
    }

    const loadVehicleHistoryAsync = async (plate) => {
        if (!isAuthenticated || user['/roles'].length === 0) {
            return;
        }

        const accessToken = await getAccessTokenSilently({
            authorizationParams: {
                audience: process.env.REACT_APP_AUTH0_API_AUDIENCE,
            }
        });

        const userRole = user['/roles'][0];
        const pageBatchSize = process.env.REACT_APP_VEHICLE_HISTORY_BATCH_SIZE;
        // if(selectedVehicleHistory.length === 0) 
        //     return;

        if (selectedVehicleHistory.length % pageBatchSize === 0) {
            const pageNo = selectedVehicleHistory.length / pageBatchSize;
            const isLoadingRefState = isLoadingRef.current;
            if (!isLoadingRefState) {
                setIsLoading(true);
                const params = {
                    plate,
                    groupName: userRole,
                    pageNo: pageNo + 1,
                    pageBatchSize,
                    currentRecordId: selectedVehicle.id
                };

                const result = await apiClient.getVehicleHistoryAsync(params, accessToken)
                const updatedVehicleHistory = [...selectedVehicleHistory, ...result]
                dispatch(setSelectedVehicleHistory(updatedVehicleHistory));
                setIsLoading(false);

            }
        }

    }

    const driveOffPaymentAsync = async () => {
        if (!isAuthenticated || user['/roles'].length === 0) {
            return;
        }
        const accessToken = await getAccessTokenSilently({
            authorizationParams: {
                audience: process.env.REACT_APP_AUTH0_API_AUDIENCE,
            }
        });

        // if(selectedVehicleHistory.length === 0) 
        //     return;

        const userRole = user['/roles'][0];
        const isLoadingRefState = isLoadingRef.current;
        if (!isLoadingRefState) {
            setIsLoading(true);
            const driveOffSettledDate = getDateTimeInfo(new Date());
            const params = {
                groupName: userRole,
                driveOffSettledDate,
            };

            await apiClient.postSettleVehicleDriveOffsAsync(vehicleDriveOffs, accessToken, params)
            setIsLoading(false);

            // Clear the drive-offs state immediately after payment
            setVehicleDriveOffs([]);

            await getSelectedVehicleForPlateAsync();
        }
    }

    const reportDriveOffAsync = async () => {
        if (!isAuthenticated || user['/roles'].length === 0) {
            return;
        }

        const accessToken = await getAccessTokenSilently({
            authorizationParams: {
                audience: process.env.REACT_APP_AUTH0_API_AUDIENCE,
            }
        });
        const userRole = user['/roles'][0];
        const isLoadingRefState = isLoadingRef.current;
        if (!isLoadingRefState) {
            setIsLoading(true);
            const params = {
                groupName: userRole,
                currentRecordId: selectedVehicle.id,
                driveOffAmount: driveOffAmount,
                reportedBy: reportedBy
            };

            const result = await apiClient.setVehicleDriveOffAsync(params, accessToken)
            setVehicleDriveOffs(result);
            setIsLoading(false);

            // Reset form and return to image view
            setDriveOffAmount('');
            setReportedBy(user.name);
            setLeftPanelView('image');

            await getSelectedVehicleForPlateAsync();
        }

    }

    const getSelectedVehicleForPlateAsync = async () => {
        if (!isAuthenticated || user['/roles'].length === 0) {
            return;
        }

        const accessToken = await getAccessTokenSilently({
            authorizationParams: {
                audience: process.env.REACT_APP_AUTH0_API_AUDIENCE,
            }
        });
        const userRole = user['/roles'][0];
        const isLoadingRefState = isLoadingRef.current;
        if (!isLoadingRefState) {
            setIsLoading(true);
            const params = {
                groupName: userRole,
                plate: selectedVehicle.plate,
                dateTimeUtc: selectedVehicle.dateTimeUtc
            };

            const result = await apiClient.getSelectedVehicleForPlateAsync(params, accessToken)
            dispatch(setSelectedVehicle(result));
            setIsLoading(false);
        }

    }



    const handleCheckRegoOnClick = () => {
        // console.log('handleCheckRegoOnClick called, current leftPanelView:', leftPanelView);
        if (!isLoading) {
            setIsLoading(true);
            // console.log('Setting leftPanelView to checkResults');
            setLeftPanelView('checkResults'); // Switch LEFT panel to show check results
            checkVehicleRegoStatusAsync()
            // checkVehicleRegoStatusAsync("ZDA573")
        } else {
            // console.log('Already loading, skipping');
        }

    }

    const handleHistoryButtonClick = () => {
        // Switch LEFT panel to show history
        if (!selectedVehicleHistory.length && !isLoading) {
            loadVehicleHistoryAsync(selectedVehicle.plate);
        }
        setLeftPanelView('history');
    };

    const handleLoadHistoryClick = () => {
        if (!selectedVehicleHistory.length && !isLoading) {
            loadVehicleHistoryAsync(selectedVehicle.plate)
        }

    }

    const handleMoreHistoryClick = () => {
        if (!isLoading) {
            loadVehicleHistoryAsync(selectedVehicle.plate)
        }

    }

    const handleDriveOffPayClick = () => {
        if (!isLoading) {
            driveOffPaymentAsync()
        }
    }


    const onDriveOffAmountChange = (event) => {
        setDriveOffAmount(event.target.value);
    };

    const onReportedByChange = (event) => {
        setReportedBy(event.target.value);
    };

    const handleReportDriveOffButtonClick = () => {
        // Switch LEFT panel to show report form
        setLeftPanelView('reportForm');
    };

    const handleReportDriveOffOnClick = () => {
        if (!isLoading && driveOffAmount && reportedBy) {
            reportDriveOffAsync();
        } else if (!driveOffAmount || !reportedBy) {
            alert('Please fill in both Amount and Reported By fields');
        }
    }



    useEffect(() => {
        setModalShow(showVehicle);
        if (selectedVehicle) {
            // Always fetch drive-offs for the selected vehicle (removed isActiveDriveOff condition)
            checkVehicleDriveOffsAsync(selectedVehicle.plate);
        }


    }, [showVehicle, selectedVehicle]);

    return (
        <PageConsumerDetailsAndReporting
            modalShow={modalShow}
            selectedVehicle={selectedVehicle}
            selectedVehicleHistory={selectedVehicleHistory}
            vehicleDriveOffs={vehicleDriveOffs}
            isLoading={isLoading}
            driveOffAmount={driveOffAmount}
            reportedBy={reportedBy}
            leftPanelView={leftPanelView}
            setLeftPanelView={setLeftPanelView}
            handleModalClose={handleModalClose}
            handleCheckRegoOnClick={handleCheckRegoOnClick}
            handleHistoryButtonClick={handleHistoryButtonClick}
            handleLoadHistoryClick={handleLoadHistoryClick}
            handleMoreHistoryClick={handleMoreHistoryClick}
            handleDriveOffPayClick={handleDriveOffPayClick}
            handleReportDriveOffButtonClick={handleReportDriveOffButtonClick}
            handleReportDriveOffOnClick={handleReportDriveOffOnClick}
            onDriveOffAmountChange={onDriveOffAmountChange}
            onReportedByChange={onReportedByChange}
            getDateTimeInfo={getDateTimeInfo}
        />
    );
}

export default SingleVehicleModalV2

